import { render, staticRenderFns } from "./TheBar.vue?vue&type=template&id=08a3b22d&"
import script from "./TheBar.vue?vue&type=script&lang=js&"
export * from "./TheBar.vue?vue&type=script&lang=js&"
import style0 from "./TheBar.vue?vue&type=style&index=0&id=08a3b22d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports